function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }
  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
    if (typeof changePrice === 'function') changePrice(getStoredPriceOption());
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)',
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    // let isMobile = window.matchMedia('(max-width: 750px)').matches;
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      // // Choose the appropriate video element based on screen size
      // let videoElement;
      // if (isMobile) {
      //   content.appendChild(this.querySelector('template').content.lastElementChild.cloneNode(true));

      //   console.log('mobile');
      // } else {
      //   content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      //   console.log('desktop');
      // }

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true },
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

document.addEventListener('DOMContentLoaded', function () {
  /* Start-Abgleich des Variantenwaehlers (Agentur-Skript, 2026-09-09 umgebaut):
     Frueher wurde je variant-selects ein change auf das erste Auswahlfeld
     gefeuert UND ein unangehaktes erstes Radio angehakt und ebenfalls gefeuert —
     zwei bis drei Abrufe je Seitenaufruf. Jetzt genau EIN Abruf, nur fuer den
     Haupt-Picker (das Slideover «Alle ansehen» ist ein zweites variant-selects
     und reicht seine Wahl an den Haupt-Picker weiter).

     Der Abruf erledigt zugleich die Default-Hauptvariante aus plentymarkets:
     Steht sie an Position 1 (LUCIA, profim FAN), ist sie beim Seitenaufruf
     vorausgewaehlt — Kaufformular traegt das Parent, alle Groessen gelten als
     nicht verfuegbar. «Default» wird in den Feldern nicht gerendert; ohne
     angehaktes Radio nehmen wir den ersten echten Wert, und der Server liefert
     die passende Variante zurueck. */
  document.querySelectorAll('variant-selects[data-section]').forEach(function (variantSelects) {
    if (variantSelects.closest('#slideover-variant')) return;
    if (variantSelects.dataset.wbStartAbgleich === '1') return;
    variantSelects.dataset.wbStartAbgleich = '1';

    let ausloeser = null;
    variantSelects.querySelectorAll('fieldset').forEach(function (fieldset) {
      const radios = Array.from(fieldset.querySelectorAll('input[type="radio"], input[type="checkbox"]'));
      if (!radios.length || radios.some((input) => input.checked)) return;
      radios[0].checked = true;
      ausloeser = ausloeser || radios[0];
    });
    /* 2026-10-07: Kein Abruf, wenn die Seite schon vollstaendig gewaehlt ankommt — jedes Radio-Feld hat
       einen Haken und jedes Auswahlfeld einen Wert (TELDRA, ART, die meisten Artikel). Der Server hat
       diese Seite bereits fuer genau diese Variante gerendert (Preis, Verfuegbarkeit der Werte,
       Lieferkasten, Galerie); der Abruf holte dieselbe Section ein zweites Mal (0,5–1,5 s Shopify-
       Render, 60 KB, Galerie-Neuaufbau) — gemessen auf jeder Produktseite mit Optionen. Er bleibt nur
       fuer den Fall, dass ein Radio-Feld ohne Haken ankam (Default-Hauptvariante aus plentymarkets,
       siehe oben) oder ein Auswahlfeld leer ist. */
    /* 2026-10-28 (Bestellung #6234, zuvor #5796): Steht die Default-Hauptvariante an Position 1 und der
       Picker ist ein Dropdown (COREX, NOVA, T-EASY, UNI …), kommt die Seite «vollstaendig gewaehlt» an —
       jedes Auswahlfeld zeigt den ersten echten Wert (Default wird nicht gerendert), aber Kaufformular,
       Preis, SKU und Galerie gehoeren noch zur Hauptvariante (selected_or_first_available_variant).
       Die Pruefung von 2026-10-07 liess das durch; «In den Warenkorb» legte das Parent in den Korb.
       Darum: Ist die mitgelieferte Startvariante die Hauptvariante, wird der Abgleich erzwungen — der
       Server liefert die Variante zu den sichtbaren Werten. Der Abruf faellt nur auf diesen Seiten an;
       bis er zurueck ist, bleibt der Kaufen-Button gesperrt (onVariantChange → toggleAddButton). */
    if (!ausloeser && wbIstHauptvariante(wbStartVariante(variantSelects))) {
      ausloeser =
        variantSelects.querySelector('select') || variantSelects.querySelector('input[type="radio"]:checked');
    }
    if (!ausloeser) {
      const leereSelects = Array.from(variantSelects.querySelectorAll('select')).filter((select) => !select.value);
      if (!leereSelects.length) return;
      ausloeser = leereSelects[0];
    }
    ausloeser = ausloeser || variantSelects.querySelector('select') || variantSelects.querySelector('input[type="radio"]');
    if (ausloeser) ausloeser.dispatchEvent(new Event('change', { bubbles: true }));
  });
});

/* 2026-10-28: Erkennt die plentymarkets-Hauptvariante («Default») am Varianten-JSON der Seite — alle
   Optionswerte (bzw. der Titel) muessen die Hauptvariante bezeichnen. Listen wie in
   snippets/wb-hauptvariante.liquid und assets/wb-color-swap.js (Staemme als Teilstring, «standard» u. ae.
   nur exakt). Neue Shop-Sprache → an allen drei Stellen nachziehen. */
function wbIstHauptvariante(variante) {
  if (!variante) return false;
  const staemme =
    /default|d[ée]faut|predefin|predetermin|por defecto|padr[ãa]o|preimpost|domy[śs]ln|v[ýy]choz|alap[ée]rtelmez|varsay[ıi]lan|oletus|f[öo]rval|standardwert|standardverdi|standardv[æa]rdi|voreinstell|implicit|prednastav|privzet|zadan/i;
  const exakt = /^\s*(standard|standaard|standart|standardowy|standardowa|norm)\s*$/i;
  let werte = Array.isArray(variante.options) ? variante.options : [];
  if (!werte.length) werte = [variante.option1, variante.option2, variante.option3].filter((w) => w != null);
  if (!werte.length && variante.title) werte = [variante.title];
  return werte.length > 0 && werte.every((w) => typeof w === 'string' && (staemme.test(w) || exakt.test(w)));
}

/* Die vom Server mitgelieferte Startvariante eines variant-selects (product-variant-picker.liquid). */
function wbStartVariante(variantSelects) {
  const script = variantSelects.querySelector('script[data-selected-variant]');
  try {
    return script ? JSON.parse(script.textContent) : null;
  } catch (e) {
    return null;
  }
}

/* 2026-10-20: Vorrat für Section-Abrufe des Variantenwählers (Nutzer: «Klick auf die Optionsfelder dauert gefühlt 3× so
   lange wie bei Desktronic»). Gemessen Desktop, Live: Grössenwechsel 0,98 s — davon 0,65–1,3 s Shopify-Render der Section
   (327 KB) + 255 ms Einsetzen; Desktronic 0,5 s ohne Abruf (Variantendaten liegen in der Seite). Deshalb werden die
   Sections der Nachbarwerte (je Option jeder andere Wert bei sonst gleicher Wahl) nach dem Laden im Leerlauf vorgeholt,
   nacheinander, nur Text — derselbe Abruf wie in renderProductInfo (gleiche URL), beim Klick bleibt dann nur das Einsetzen.
   Nicht bei Datensparmodus/2G/3G. Nach jedem Wechsel wird die neue Nachbarschaft nachgeholt (schon Gemerktes kostet nichts). */
const wbSectionVorrat = new Map();
const WB_SECTION_VORRAT_MAX = 40;
function wbSectionHolen(url) {
  if (wbSectionVorrat.has(url)) return wbSectionVorrat.get(url);
  const versprechen = fetch(url).then((antwort) => {
    if (!antwort.ok) throw new Error('Status ' + antwort.status);
    return antwort.text();
  });
  versprechen.catch(() => wbSectionVorrat.delete(url));
  if (wbSectionVorrat.size >= WB_SECTION_VORRAT_MAX) wbSectionVorrat.delete(wbSectionVorrat.keys().next().value);
  wbSectionVorrat.set(url, versprechen);
  return versprechen;
}
function wbImLeerlauf(fn) {
  /* timeout 1000 statt 3000: Nach `load` ist der Browser durch Apps/Vorschauleiste selten «leer», die Kette startete
     erst 3,3 s nach load (gemessen 20.10.); der Abruf selbst belastet den Hauptthread nicht. */
  if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 1000 });
  else window.setTimeout(fn, 500);
}
/* Erstes Hauptbild der vorgeholten Section gleich mitladen (gemessen 20.10.: Bild kam 300 ms nach Preis/URL, weil es
   erst beim Einsetzen angefordert wurde — hinter 13 Thumbs). Gleiches Rezept wie hauptbildVorladen in wb-color-swap.js:
   src/srcset/sizes aus dem Markup, damit der Browser exakt dieselbe Datei wählt. */
const wbVorgeladeneBilder = {};
function wbHauptbildVorladen(html) {
  if (!html) return;
  const tag = /id="main-swiper-[^"]*"[\s\S]*?<img([^>]*)>/.exec(html);
  if (!tag) return;
  const attribut = (name) => {
    const m = new RegExp('\\s' + name + '="([^"]*)"').exec(tag[1]);
    return m ? m[1].replace(/&amp;/g, '&') : '';
  };
  const src = attribut('src');
  if (!src) return;
  const srcset = attribut('srcset');
  const sizes = attribut('sizes');
  const schluessel = src + '|' + srcset + '|' + sizes;
  if (wbVorgeladeneBilder[schluessel]) return;
  const bild = new Image();
  bild.decoding = 'async';
  if ('fetchPriority' in bild) bild.fetchPriority = 'low';
  if (sizes) bild.sizes = sizes;
  if (srcset) bild.srcset = srcset;
  bild.src = src;
  wbVorgeladeneBilder[schluessel] = bild;
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    const allMainImages = $('.product__media-swiper .product__media-item');
    const allThumbImages = $('.product__media-thumb-swiper .thumbnail-list__item');
    //this.updateOptions();
    //this.updateMasterId();

    this.addEventListener('change', (event) => this.onVariantChange(event, allMainImages, allThumbImages));
    // Onedot Var Img Change -- Start
    // if (document.querySelector('[data-var-images]').getAttribute('data-var-images') !== '') {
    //   if (this.currentVariant && this.currentVariant.sku) {
    //     this.filterMedia(this.currentVariant.sku, allMainImages, allThumbImages);
    //   }
    // }
    // Onedot Var Img Change -- End
  }

  onVariantChange(event, allMainImages, allThumbImages) {
    /* 2026-09-09: Die Variante wird nicht mehr im Browser aus einem
       Varianten-JSON gesucht (Shopify liefert hoechstens 250 — beim LUCIA-Artikel
       mit 361 Varianten war ein Drittel nicht kaufbar), sondern der Server
       rendert die Section fuer die gewaehlten Optionswerte (?option_values=…)
       und liefert die Variante als JSON mit. Verfuegbarkeit der Optionswerte
       kommt ebenfalls vom Server (value.available), updateVariantStatuses ist weg. */
    /* Das Slideover «Alle ansehen» (od-variant-slideover.liquid) ist ein zweites
       variant-selects mit derselben ID und nur der Bezugsfarbe. Es holt nichts
       selbst, sondern reicht die Wahl an den Haupt-Picker weiter — der hat alle
       Optionen und tauscht seine Felder aus dem Server-HTML aus. */
    if (this.closest('#slideover-variant')) {
      const gewaehlt = this.getInputForEventTarget(event.target);
      const haupt = document.querySelector('.product__info-container variant-selects');
      const ziel = haupt?.querySelector(
        `input[type="radio"][data-option-name="${CSS.escape(gewaehlt?.dataset.optionName || '')}"][value="${CSS.escape(gewaehlt?.value || '')}"]`,
      );
      if (ziel && !ziel.checked) {
        ziel.checked = true;
        ziel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    this.updateOptions();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();
    this.wbZuletztGeaendert = this.getInputForEventTarget(event.target);
    this.renderProductInfo(this.selectedOptionValues, this.wbZuletztGeaendert?.id);
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  /* IDs der gewaehlten Optionswerte in Optionsreihenfolge (Attribut
     data-option-value-id aus product-variant-options.liquid). Fehlt in einem
     Feld ein gewaehlter Wert, bleibt die ID weg — der Server faellt dann fuer
     diese Option auf seinen Standard zurueck. */
  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select, fieldset'))
      .map((element) => {
        const gewaehlt =
          element.tagName === 'SELECT' ? element.selectedOptions[0] : element.querySelector('input:checked');
        return gewaehlt?.dataset.optionValueId;
      })
      .filter(Boolean);
  }

  // Onedot Var Img Change -- Start

  // firstLoadFilterMedia(allMainImages, allThumbImages) {
  //   setTimeout(() => {
  //     if (document.querySelector('ul.thumbnail-list')) {
  //       document.querySelector('ul.thumbnail-list').scrollLeft = 0;
  //     }
  //     if (this.currentVariant && this.currentVariant.sku) {
  //       console.log(this.currentVariant && this.currentVariant.sku);

  //       this.filterMedia(this.currentVariant.sku, allMainImages, allThumbImages);
  //     }
  //   }, 500);
  // }

  filterMedia(sku, mainImages, thumbImages) {
    const varVideoData = $('.product__media-video');
    const varVideoThumb = $('.product__media-video-thumb');
    const varImagesData = $('[data-var-images]').data('var-images');
    if (!varImagesData || Object.keys(varImagesData).length === 0) {
      return;
    }

    const currentSku = sku || $('#sku-inner').text();
    const imagesForCurrentSku = varImagesData[currentSku];

    const mainImageList = $('.product__media-swiper');
    const thumbImageList = $('.product__media-thumb-swiper');
    const thumbVideo = $('.product__media-video-thumb--video');

    let imagesForCurrentSkuArrReverse = [];
    Object.entries(imagesForCurrentSku).forEach((item) => {
      imagesForCurrentSkuArrReverse.push(item[1]);
    });

    let i = 0;
    if (window.innerWidth < 1024) {
      let i = thumbVideo.length > 0 ? -1 : 0;
      mainImageList.children().each(function (index, element) {
        const $element = $(element); // jQuery-Objekt des aktuellen Kind-Elements
        if (imagesForCurrentSkuArrReverse.includes(i)) {
          $element.show();
        } else {
          $element.hide();
        }
        i++;
      });
    }

    let c = thumbVideo.length > 0 ? -1 : 0;
    thumbImageList.children().each(function (index, element) {
      const $element = $(element); // jQuery-Objekt des aktuellen Kind-Elements

      if (imagesForCurrentSkuArrReverse.includes(c) || c === -1) {
        $element.show();
      } else {
        $element.hide();
      }
      c++;
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset',
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateMedia(html) {
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
    const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${sectionId}"] ul`);

    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
      const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
      const sourceMap = new Map(
        mediaGallerySourceItems.map((item, index) => [
          item.dataset.mediaId,
          {
            item,
            index,
          },
        ]),
      );
      return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
      const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
      let shouldRefresh = false;

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
          shouldRefresh = true;
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      // refresh
      if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
        const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

        if (sourceData && sourceData.index !== destinationIndex) {
          mediaGallerySource.insertBefore(
            sourceData.item,
            mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`),
          );

          // refresh source now that it has been modified
          [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        }
      });
    }

    if (this.currentVariant.featured_media) {
      document
        .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
        ?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
    }

    // update media modal
    const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
    const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
    if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
  }

  /* Ersetzt die Optionsfelder durch die vom Server gerenderten (Verfuegbarkeit
     und Vorauswahl passend zur neuen Kombination). Nur der Inhalt wird
     getauscht, das Element und seine Listener bleiben; das JSON-Script bleibt
     als Anker stehen. Fokus zurueck auf das zuletzt bediente Feld, damit
     Tastaturbedienung nicht abreisst. */
  updateOptionValues(html, targetId) {
    if (this.closest('#slideover-variant')) return;
    const quelle =
      html.querySelector(`#variant-selects-${this.dataset.originalSection || this.dataset.section}`) ||
      html.querySelector('variant-selects');
    if (!quelle) return;
    const neu = Array.from(quelle.children).filter((el) => el.tagName !== 'SCRIPT');
    Array.from(this.children)
      .filter((el) => el.tagName !== 'SCRIPT')
      .forEach((el) => el.remove());
    const anker = this.querySelector('script[data-selected-variant]');
    neu.forEach((el) => this.insertBefore(document.importNode(el, true), anker));
    this.dispatchEvent(new CustomEvent('wb:optionen-aktualisiert'));
    if (targetId) document.getElementById(targetId)?.focus({ preventScroll: true });
  }

  leseVariante(html) {
    const script = html.querySelector('variant-selects script[data-selected-variant]');
    try {
      return script ? JSON.parse(script.textContent) : null;
    } catch (e) {
      return null;
    }
  }

  /* Rueckfall fuer renderProductInfo (2026-09-22): Varianten-ID zu den gewaehlten
     Optionstexten. Das Produkt-JSON wird je Seite nur einmal geholt. */
  async varianteUeberNamen() {
    try {
      if (!this.wbProduktDaten) {
        this.wbProduktDaten = fetch(`${this.dataset.url}.js`).then((r) => (r.ok ? r.json() : null));
      }
      const produkt = await this.wbProduktDaten;
      if (!produkt || !Array.isArray(produkt.variants)) return null;
      const werte = Array.from(this.querySelectorAll('select, fieldset'), (element) =>
        element.tagName === 'SELECT' ? element.value : element.querySelector('input:checked')?.value,
      );
      if (werte.some((w) => !w)) return null;
      const treffer = produkt.variants.find((v) => werte.every((w, i) => v.options[i] === w));
      return treffer ? treffer.id : null;
    } catch (e) {
      return null;
    }
  }

  /* 2026-10-02: Luecke im Variantenraster (z. B. TELDRA Pro Curve: «abgerundet»
     gibt es nur in 1600/1800). Statt «Nicht verfuegbar» springt die Auswahl auf
     die naechstliegende Variante, die den SOEBEN gewaehlten Wert enthaelt. Beim
     Ausweichen werden hintere Optionen (Tischplattenform) zuerst gewechselt,
     vordere (Gestellfarbe) zuletzt; verfuegbare Varianten vor ausverkauften.
     Liefert die Varianten-ID und stellt die Felder schon um — die Section wird
     danach per ?variant= geholt und tauscht die Felder aus dem Server-HTML. */
  async naechsteGueltigeVariante(targetId) {
    try {
      if (!this.wbProduktDaten) {
        this.wbProduktDaten = fetch(`${this.dataset.url}.js`).then((r) => (r.ok ? r.json() : null));
      }
      const produkt = await this.wbProduktDaten;
      if (!produkt || !Array.isArray(produkt.variants)) return null;
      const felder = Array.from(this.querySelectorAll('select, fieldset'));
      const werte = felder.map((f) =>
        f.tagName === 'SELECT' ? f.value : f.querySelector('input:checked')?.value,
      );
      const ziel = this.wbZuletztGeaendert || (targetId ? document.getElementById(targetId) : null);
      const fest = felder.findIndex((f) => ziel && f.contains(ziel));
      if (fest < 0 || !werte[fest]) return null;
      const kandidaten = produkt.variants.filter(
        (v) => v.options[fest] === werte[fest] && !v.options.every((o) => o === 'Default'),
      );
      if (!kandidaten.length) return null;
      const n = werte.length;
      const kosten = (v) =>
        werte.reduce((summe, w, i) => (i !== fest && v.options[i] !== w ? summe + 2 ** (n - 1 - i) : summe), 0);
      kandidaten.sort((a, b) => kosten(a) - kosten(b) || (b.available ? 1 : 0) - (a.available ? 1 : 0));
      const treffer = kandidaten[0];
      felder.forEach((f, i) => {
        if (i === fest) return;
        const wert = treffer.options[i];
        if (f.tagName === 'SELECT') {
          if (Array.from(f.options).some((o) => o.value === wert)) f.value = wert;
        } else {
          const radio = Array.from(f.querySelectorAll('input')).find((r) => r.value === wert);
          if (radio) radio.checked = true;
        }
      });
      this.updateOptions();
      return treffer.id;
    } catch (e) {
      return null;
    }
  }

  /* 2026-10-20: Abruf-URL an EINER Stelle, damit Vorrat und Klick dieselbe URL treffen. */
  wbSectionUrl(optionValueIds) {
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const params = [`section_id=${sectionId}`];
    if (optionValueIds.length) params.push(`option_values=${optionValueIds.join(',')}`);
    return `${this.dataset.url}?${params.join('&')}`;
  }

  connectedCallback() {
    if (this.closest('#slideover-variant') || !this.dataset.url) return;
    /* Erst nach dem Laden der Seite und wenn der Wähler (fast) im Bild ist. */
    const starten = () => {
      if (!('IntersectionObserver' in window)) return this.wbVorladenPlanen();
      const beobachter = new IntersectionObserver(
        (eintraege) => {
          if (!eintraege.some((e) => e.isIntersecting)) return;
          beobachter.disconnect();
          this.wbVorladenPlanen();
        },
        { rootMargin: '200px 0px' },
      );
      beobachter.observe(this);
    };
    if (document.readyState === 'complete') starten();
    else window.addEventListener('load', starten, { once: true });
  }

  /* Nachbarwerte bestimmen: je Option jeder andere wählbare Wert bei sonst gleicher Wahl. */
  wbNachbarUrls() {
    const felder = Array.from(this.querySelectorAll('select, fieldset'));
    const gewaehlt = felder.map((feld) => {
      const g = feld.tagName === 'SELECT' ? feld.selectedOptions[0] : feld.querySelector('input:checked');
      return g?.dataset.optionValueId;
    });
    const urls = [];
    felder.forEach((feld, i) => {
      const werte = feld.tagName === 'SELECT' ? Array.from(feld.options) : Array.from(feld.querySelectorAll('input'));
      werte.forEach((wert) => {
        const id = wert.dataset.optionValueId;
        if (!id || id === gewaehlt[i] || wert.disabled) return;
        const ids = gewaehlt.slice();
        ids[i] = id;
        urls.push(this.wbSectionUrl(ids.filter(Boolean)));
      });
    });
    return urls.filter((url, k) => urls.indexOf(url) === k && !wbSectionVorrat.has(url)).slice(0, 12);
  }

  /* sofort = true (nach einem Wechsel): ohne Leerlauf-Wartezeit starten — der Kunde klickt oft direkt das nächste Feld
     (Nutzer 20.10.: «die Gestellfarbe dauert aber noch sehr lange» — Nachbarn der neuen Wahl waren noch nicht da).
     Zwei Abrufe parallel (Desktronic-Vergleich: deren Abruf 33 KB in ~200 ms; unserer seit der schlankeren Section
     ~150–350 ms, vorher 0,65–1,3 s). */
  wbVorladenPlanen(sofort) {
    const netz = navigator.connection;
    if (netz && (netz.saveData || /2g|3g/.test(netz.effectiveType || ''))) return;
    this.wbVorladeLauf = (this.wbVorladeLauf || 0) + 1;
    const lauf = this.wbVorladeLauf;
    const PARALLEL = 2;
    const starten = () => {
      if (lauf !== this.wbVorladeLauf || !this.isConnected) return;
      const urls = this.wbNachbarUrls();
      const naechste = () => {
        if (lauf !== this.wbVorladeLauf || !this.isConnected) return;
        const url = urls.shift();
        if (!url) return;
        /* Kette ohne weitere Leerlauf-Pausen (gemessen: je Pause ~2 s, 6 Abrufe brauchten 4 s statt 1 s);
           der Abruf selbst belastet den Hauptthread nicht. */
        const weiter = naechste;
        wbSectionHolen(url)
          .then(wbHauptbildVorladen)
          .catch(() => {})
          .then(weiter);
      };
      for (let i = 0; i < PARALLEL; i++) naechste();
    };
    if (sofort) window.setTimeout(starten, 0);
    else wbImLeerlauf(starten);
  }

  renderProductInfo(optionValueIds = this.selectedOptionValues, targetId) {
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    /* 2026-09-09: Abruf ueber option_values statt variant — so kennt der Server
       auch Varianten jenseits der ersten 250 und liefert sie als JSON zurueck. */
    const anfrage = this.wbSectionUrl(optionValueIds);
    this.letzteAnfrage = anfrage;

    /* 2026-10-20: aus dem Vorrat (siehe wbSectionHolen), sonst normaler Abruf. */
    wbSectionHolen(anfrage)
      .then(async (responseText) => {
        // Nur die juengste Anfrage darf einsetzen (schnelle Mehrfachklicks)
        if (this.letzteAnfrage !== anfrage) return;

        let html = new DOMParser().parseFromString(responseText, 'text/html');
        this.currentVariant = this.leseVariante(html);

        /* 2026-09-22: Bei einzelnen Artikeln loest Shopify option_values gar nicht
           auf (TELDRA 2.0 Linoleum Pebble: selbst ein einzelner Wert liefert null,
           obwohl alle Kombinationen existieren) — Preis weg, «Nicht verfuegbar».
           Rueckfall: Variante ueber die Optionsnamen aus /products/<handle>.js
           suchen und die Section klassisch per ?variant= holen. Gibt es die
           Kombination wirklich nicht, bleibt es bei «Nicht verfuegbar». */
        if (!this.currentVariant && optionValueIds.length) {
          const ersatzId = await this.varianteUeberNamen();
          if (this.letzteAnfrage !== anfrage) return;
          if (ersatzId) {
            const antwort = await fetch(`${this.dataset.url}?section_id=${sectionId}&variant=${ersatzId}`).then((r) => r.text());
            if (this.letzteAnfrage !== anfrage) return;
            html = new DOMParser().parseFromString(antwort, 'text/html');
            this.currentVariant = this.leseVariante(html);
          }
        }
        /* 2026-10-02: Kombination gibt es wirklich nicht → auf die naechstliegende
           Variante mit dem soeben gewaehlten Wert springen (siehe naechsteGueltigeVariante). */
        if (!this.currentVariant && optionValueIds.length && (this.wbZuletztGeaendert || targetId)) {
          const sprungId = await this.naechsteGueltigeVariante(targetId);
          if (this.letzteAnfrage !== anfrage) return;
          if (sprungId) {
            const antwort = await fetch(`${this.dataset.url}?section_id=${sectionId}&variant=${sprungId}`).then((r) => r.text());
            if (this.letzteAnfrage !== anfrage) return;
            html = new DOMParser().parseFromString(antwort, 'text/html');
            this.currentVariant = this.leseVariante(html);
          }
        }
        /* 2026-10-28: Liefert der Server zu den gewaehlten Werten die Hauptvariante, gilt die Wahl als
           nicht verfuegbar — das Parent darf nie ins Kaufformular (Bestellung #6234). */
        if (this.currentVariant && wbIstHauptvariante(this.currentVariant)) this.currentVariant = null;
        const jsonScript = this.querySelector('script[data-selected-variant]');
        if (jsonScript) jsonScript.textContent = JSON.stringify(this.currentVariant);
        this.updateOptionValues(html, targetId);

        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
          return;
        }
        this.updateURL();
        this.updateVariantInput();
        this.updateShareUrl();
        this.updatePickupAvailability();
        /* 2026-10-20: Nachbarwerte der neuen Wahl sofort nachholen (wbSectionVorrat). */
        this.wbVorladenPlanen(true);

        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const badgeSource = html.getElementById(
          `badge-wrapper-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const badgeDestination = document.getElementById(`badge-wrapper-${this.dataset.section}`);
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const accordionSkuSource = html.getElementById(`ContactForm-sku`);
        const accordionSkuDestination = document.getElementById(`ContactForm-sku`);
        const technicalDataSource = html.getElementById(
          `technical-data-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const shippingSlideoverDestination = document.getElementById(`shipping_slideover`);

        const shippingSlideoverSource = html.getElementById(`shipping_slideover`);

        const technicalDataDestination = document.getElementById(`technical-data-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const mediaGalleryDestination = document.getElementById(`product-media-gallery-${this.dataset.section}`);
        const mediaGallerySource = html.getElementById(
          `product-media-gallery-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );

        this.updateMedia(html);

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (mediaGallerySource && mediaGalleryDestination) {
          let currentPositon = window.mainswiper.activeIndex;
          mediaGalleryDestination.innerHTML = mediaGallerySource.innerHTML;

          var thumbswiper = new Swiper(`#thumb-swiper-${this.dataset.section}`, {
            // Optional parameters
            lazy: true,
            initialSlide: currentPositon,
            /* Handy (2026-10-21): 4,7 Thumbs je Reihe, je ein Thumb pro Wisch, das fünfte angeschnitten;
               ab 750 px 7/10 mit Pfeilen. Gleich wie in beiden Galerie-Snippets. */
            slidesPerView: 4.7,
            slidesPerGroup: 1,

            keyboard: {
              enabled: true,
            },
            breakpoints: {
              640: {
                slidesPerView: 6.7,
                slidesPerGroup: 1,
              },
              750: {
                slidesPerView: 7,
                slidesPerGroup: 3,
              },
              990: {
                slidesPerView: 10,
                slidesPerGroup: 3,
              },
            },
            spaceBetween: 8,
            // Navigation arrows
            navigation: {
              nextEl: '.next-btn',
              prevEl: '.prev-btn',
            },
          });

          var mainswiper = new Swiper(`#main-swiper-${this.dataset.section}`, {
            // Optional parameters
            lazy: true,
            /* 2026-09-22: je zwei Nachbarbilder vorladen — sonst holt und entpackt Safari das
               naechste Bild erst waehrend der Wischbewegung (Nutzer: «bei vielen Bildern
               traege und hakelig»). */
            lazyPreloadPrevNext: 2,
            initialSlide: currentPositon,

            /* Handy (2026-09-22, Nutzer: «die anderen Bilder links und rechts vom aktuellen Bild
               angeschnitten, wie bei desktronic»): 1,0575 Bilder je Ansicht (= 340-px-Bild nach desktronic-Mass; davor 1,19 und 1,12), zentriert, 8 px Lücke —
               die Nachbarn lugen beidseitig ~6 % hervor. Ab 750 px unverändert ein Bild in voller
               Breite. Mobile-first: Basiswerte = Handy. Dieselben Werte stehen in BEIDEN Galerie-
               Snippets und in global.js (Neuaufbau beim Variantenwechsel) — immer zu dritt ändern. */
            /* 2026-10-21: wieder ein Bild in voller Breite am Handy, kein Anschnitt (wie in beiden Galerie-Snippets). */
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 8,
            breakpoints: {
              750: {
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 16,
              },
            },
            thumbs: {
              swiper: thumbswiper,
              autoScrollOffset: 1,
            },
            keyboard: {
              enabled: true,
            },
            // 2026-10-09: Doppeltipp/Pinch-Zoom am Handy (wie in den Galerie-Snippets, Erklärung im plenty-Snippet)
            zoom: {
              maxRatio: 3,
            },
          });
          window.mainswiper = mainswiper;
          if (mainswiper.zoom) mainswiper.zoom.disable(); // 2026-10-09 spät: eigener Handy-Zoom in main-product.liquid

          // 2026-10-10: Lightbox entfernt — Zoom im Bild (Desktop Klick, Handy Doppeltipp/Pinch, sections/main-product.liquid).
        }
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }
        if (badgeSource && badgeDestination) {
          badgeDestination.innerHTML = badgeSource.innerHTML;
          badgeDestination.classList.toggle('hidden', badgeSource.classList.contains('hidden'));
        }
        if (accordionSkuSource && accordionSkuDestination) {
          accordionSkuDestination.value = accordionSkuSource.value;
          accordionSkuDestination.classList.toggle('hidden', accordionSkuSource.classList.contains('hidden'));
        }
        if (technicalDataDestination && technicalDataSource) {
          technicalDataDestination.innerHTML = technicalDataSource.innerHTML;
          technicalDataDestination.classList.toggle('hidden', technicalDataSource.classList.contains('hidden'));
        }
        if (shippingSlideoverDestination && shippingSlideoverSource) {
          shippingSlideoverDestination.innerHTML = shippingSlideoverSource.innerHTML;
          shippingSlideoverDestination.classList.toggle('hidden', shippingSlideoverSource.classList.contains('hidden'));
        }

        /* 2026-09-09: Lieferkasten aus der Server-Antwort — die Varianten-Map in
           wb-delivery-box.liquid kennt nur 250 Varianten, der Server kennt alle.
           Der Wrapper enthaelt Map und Kaesten der neuen Antwort; das Snippet-Skript
           liest beides bei jedem Sync frisch aus dem DOM. */
        const lieferQuelle = html.querySelector('.wb-delivery-wrap');
        const lieferZiel = document.querySelector(`#MainProduct-${this.dataset.section} .wb-delivery-wrap`);
        if (lieferQuelle && lieferZiel) lieferZiel.innerHTML = lieferQuelle.innerHTML;
        /* Das Snippet-Skript des Lieferkastens liest [name=id] sonst nur 150/800 ms
           nach dem change — bei langsamer Antwort zu frueh. Gleiches Signal wie
           beim Farbwechsel ohne Reload (wb-color-swap.js). */
        document.dispatchEvent(
          new CustomEvent('wb:variantenwechsel', { detail: { variantId: this.currentVariant.id } }),
        );

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        if (typeof changePrice === 'function') changePrice(getStoredPriceOption());

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut,
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            if (typeof changePrice === 'function') changePrice(getStoredPriceOption());
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.swiper-slide')) {
            this.classList.add('product-recommendations--loaded');

            var swiper = new Swiper('#swiper-recomandations', {
              slidesPerView: 2,
              spaceBetween: 16,
              observer: true,
              scrollbar: {
                el: '.swiper-scrollbar',
              },
              breakpoints: {
                640: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                990: {
                  slidesPerView: 4,
                },
              },
              navigation: {
                nextEl: '.next-btn',
                prevEl: '.prev-btn',
              },
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

